export const arrestDates = [
  {
    arrest_date: "10/15/2025",
    days_in: 1,
    number_of_arrests: 5,
  },
  {
    arrest_date: "10/16/2025",
    days_in: 2,
    number_of_arrests: 5,
  },
  {
    arrest_date: "10/17/2025",
    days_in: 3,
    number_of_arrests: 5,
  },
  {
    arrest_date: "10/20/2025",
    days_in: 6,
    number_of_arrests: 6,
  },
  {
    arrest_date: "10/21/2025",
    days_in: 7,
    number_of_arrests: 5,
  },
  {
    arrest_date: "10/22/2025",
    days_in: 8,
    number_of_arrests: 5,
  },
  {
    arrest_date: "10/23/2025",
    days_in: 9,
    number_of_arrests: 6,
  },
  {
    arrest_date: "10/24/2025",
    days_in: 10,
    number_of_arrests: 5,
  },
  {
    arrest_date: "10/25/2025",
    days_in: 11,
    number_of_arrests: 3,
  },
  {
    arrest_date: "10/26/2025",
    days_in: 12,
    number_of_arrests: 2,
  },
  {
    arrest_date: "10/27/2025",
    days_in: 13,
    number_of_arrests: 2,
  },
  {
    arrest_date: "10/28/2025",
    days_in: 14,
    number_of_arrests: 3,
  },
  {
    arrest_date: "10/29/2025",
    days_in: 15,
    number_of_arrests: 10,
  },
  {
    arrest_date: "10/30/2025",
    days_in: 16,
    number_of_arrests: 3,
  },
  {
    arrest_date: "10/31/2025",
    days_in: 17,
    number_of_arrests: 6,
  },
  {
    arrest_date: "11/1/2025",
    days_in: 18,
    number_of_arrests: 13,
  },
  {
    arrest_date: "11/2/2025",
    days_in: 19,
    number_of_arrests: 3,
  },
  {
    arrest_date: "11/3/2025",
    days_in: 20,
    number_of_arrests: 5,
  },
  {
    arrest_date: "11/4/2025",
    days_in: 21,
    number_of_arrests: 8,
  },
  {
    arrest_date: "11/5/2025",
    days_in: 22,
    number_of_arrests: 6,
  },
  {
    arrest_date: "11/6/2025",
    days_in: 23,
    number_of_arrests: 11,
  },
  {
    arrest_date: "11/7/2025",
    days_in: 24,
    number_of_arrests: 8,
  },
  {
    arrest_date: "11/8/2025",
    days_in: 25,
    number_of_arrests: 6,
  },
  {
    arrest_date: "11/9/2025",
    days_in: 26,
    number_of_arrests: 1,
  },
  {
    arrest_date: "11/10/2025",
    days_in: 27,
    number_of_arrests: 6,
  },
  {
    arrest_date: "11/11/2025",
    days_in: 28,
    number_of_arrests: 7,
  },
  {
    arrest_date: "11/12/2025",
    days_in: 29,
    number_of_arrests: 5,
  },
  {
    arrest_date: "11/13/2025",
    days_in: 30,
    number_of_arrests: 6,
  },
  {
    arrest_date: "11/14/2025",
    days_in: 31,
    number_of_arrests: 7,
  },
  {
    arrest_date: "11/15/2025",
    days_in: 32,
    number_of_arrests: 1,
  },
  {
    arrest_date: "11/16/2025",
    days_in: 33,
    number_of_arrests: 2,
  },
  {
    arrest_date: "11/17/2025",
    days_in: 34,
    number_of_arrests: 3,
  },
  {
    arrest_date: "11/18/2025",
    days_in: 35,
    number_of_arrests: 8,
  },
  {
    arrest_date: "11/19/2025",
    days_in: 36,
    number_of_arrests: 6,
  },
  {
    arrest_date: "11/20/2025",
    days_in: 37,
    number_of_arrests: 4,
  },
  {
    arrest_date: "11/21/2025",
    days_in: 38,
    number_of_arrests: 2,
  },
  {
    arrest_date: "11/22/2025",
    days_in: 39,
    number_of_arrests: 3,
  },
  {
    arrest_date: "11/23/2025",
    days_in: 40,
    number_of_arrests: 8,
  },
  {
    arrest_date: "11/24/2025",
    days_in: 41,
    number_of_arrests: 7,
  },
  {
    arrest_date: "11/25/2025",
    days_in: 42,
    number_of_arrests: 5,
  },
  {
    arrest_date: "11/26/2025",
    days_in: 43,
    number_of_arrests: 9,
  },
  {
    arrest_date: "11/27/2025",
    days_in: 44,
    number_of_arrests: 2,
  },
  {
    arrest_date: "11/28/2025",
    days_in: 45,
    number_of_arrests: 3,
  },
  {
    arrest_date: "11/29/2025",
    days_in: 46,
    number_of_arrests: 3,
  },
  {
    arrest_date: "11/30/2025",
    days_in: 47,
    number_of_arrests: 1,
  },
  {
    arrest_date: "12/1/2025",
    days_in: 48,
    number_of_arrests: 9,
  },
  {
    arrest_date: "12/2/2025",
    days_in: 49,
    number_of_arrests: 9,
  },
  {
    arrest_date: "12/3/2025",
    days_in: 50,
    number_of_arrests: 13,
  },
  {
    arrest_date: "12/4/2025",
    days_in: 51,
    number_of_arrests: 15,
  },
  {
    arrest_date: "12/5/2025",
    days_in: 52,
    number_of_arrests: 7,
  },
  {
    arrest_date: "12/6/2025",
    days_in: 53,
    number_of_arrests: 8,
  },
  {
    arrest_date: "12/7/2025",
    days_in: 54,
    number_of_arrests: 2,
  },
  {
    arrest_date: "12/8/2025",
    days_in: 55,
    number_of_arrests: 14,
  },
  {
    arrest_date: "12/9/2025",
    days_in: 56,
    number_of_arrests: 9,
  },
  {
    arrest_date: "12/10/2025",
    days_in: 57,
    number_of_arrests: 10,
  },
  {
    arrest_date: "12/11/2025",
    days_in: 58,
    number_of_arrests: 7,
  },
  {
    arrest_date: "12/12/2025",
    days_in: 59,
    number_of_arrests: 5,
  },
  {
    arrest_date: "12/13/2025",
    days_in: 60,
    number_of_arrests: 6,
  },
  {
    arrest_date: "12/14/2025",
    days_in: 61,
    number_of_arrests: 2,
  },
  {
    arrest_date: "12/15/2025",
    days_in: 62,
    number_of_arrests: 5,
  },
  {
    arrest_date: "12/16/2025",
    days_in: 63,
    number_of_arrests: 8,
  },
  {
    arrest_date: "12/17/2025",
    days_in: 64,
    number_of_arrests: 5,
  },
  {
    arrest_date: "12/18/2025",
    days_in: 65,
    number_of_arrests: 2,
  },
  {
    arrest_date: "12/19/2025",
    days_in: 66,
    number_of_arrests: 2,
  },
  {
    arrest_date: "12/20/2025",
    days_in: 67,
    number_of_arrests: 8,
  },
  {
    arrest_date: "12/21/2025",
    days_in: 68,
    number_of_arrests: 2,
  },
  {
    arrest_date: "12/22/2025",
    days_in: 69,
    number_of_arrests: 3,
  },
  {
    arrest_date: "12/23/2025",
    days_in: 70,
    number_of_arrests: 2,
  },
  {
    arrest_date: "12/24/2025",
    days_in: 71,
    number_of_arrests: 5,
  },
  {
    arrest_date: "12/25/2025",
    days_in: 72,
    number_of_arrests: 2,
  },
  {
    arrest_date: "12/26/2025",
    days_in: 73,
    number_of_arrests: 7,
  },
  {
    arrest_date: "12/28/2025",
    days_in: 75,
    number_of_arrests: 1,
  },
  {
    arrest_date: "12/29/2025",
    days_in: 76,
    number_of_arrests: 14,
  },
  {
    arrest_date: "12/30/2025",
    days_in: 77,
    number_of_arrests: 7,
  },
  {
    arrest_date: "12/31/2025",
    days_in: 78,
    number_of_arrests: 5,
  },
  {
    arrest_date: "1/1/2026",
    days_in: 79,
    number_of_arrests: 11,
  },
  {
    arrest_date: "1/2/2026",
    days_in: 80,
    number_of_arrests: 1,
  },
  {
    arrest_date: "1/3/2026",
    days_in: 81,
    number_of_arrests: 5,
  },
  {
    arrest_date: "1/5/2026",
    days_in: 83,
    number_of_arrests: 7,
  },
  {
    arrest_date: "1/6/2026",
    days_in: 84,
    number_of_arrests: 16,
  },
  {
    arrest_date: "1/7/2026",
    days_in: 85,
    number_of_arrests: 6,
  },
  {
    arrest_date: "1/8/2026",
    days_in: 86,
    number_of_arrests: 11,
  },
  {
    arrest_date: "1/9/2026",
    days_in: 87,
    number_of_arrests: 9,
  },
  {
    arrest_date: "1/10/2026",
    days_in: 88,
    number_of_arrests: 8,
  },
  {
    arrest_date: "1/11/2026",
    days_in: 89,
    number_of_arrests: 6,
  },
  {
    arrest_date: "1/12/2026",
    days_in: 90,
    number_of_arrests: 13,
  },
  {
    arrest_date: "1/13/2026",
    days_in: 91,
    number_of_arrests: 15,
  },
  {
    arrest_date: "1/14/2026",
    days_in: 92,
    number_of_arrests: 7,
  },
  {
    arrest_date: "1/15/2026",
    days_in: 93,
    number_of_arrests: 13,
  },
  {
    arrest_date: "1/16/2026",
    days_in: 94,
    number_of_arrests: 4,
  },
  {
    arrest_date: "1/17/2026",
    days_in: 95,
    number_of_arrests: 7,
  },
  {
    arrest_date: "1/18/2026",
    days_in: 96,
    number_of_arrests: 3,
  },
  {
    arrest_date: "1/19/2026",
    days_in: 97,
    number_of_arrests: 6,
  },
  {
    arrest_date: "1/20/2026",
    days_in: 98,
    number_of_arrests: 13,
  },
  {
    arrest_date: "1/21/2026",
    days_in: 99,
    number_of_arrests: 9,
  },
  {
    arrest_date: "1/22/2026",
    days_in: 100,
    number_of_arrests: 19,
  },
  {
    arrest_date: "1/23/2026",
    days_in: 101,
    number_of_arrests: 3,
  },
  {
    arrest_date: "1/24/2026",
    days_in: 102,
    number_of_arrests: 14,
  },
  {
    arrest_date: "1/26/2026",
    days_in: 104,
    number_of_arrests: 1,
  },
  {
    arrest_date: "1/27/2026",
    days_in: 105,
    number_of_arrests: 17,
  },
  {
    arrest_date: "1/28/2026",
    days_in: 106,
    number_of_arrests: 15,
  },
  {
    arrest_date: "1/29/2026",
    days_in: 107,
    number_of_arrests: 14,
  },
  {
    arrest_date: "1/30/2026",
    days_in: 108,
    number_of_arrests: 8,
  },
  {
    arrest_date: "1/31/2026",
    days_in: 109,
    number_of_arrests: 6,
  },
  {
    arrest_date: "2/1/2026",
    days_in: 110,
    number_of_arrests: 9,
  },
  {
    arrest_date: "2/2/2026",
    days_in: 111,
    number_of_arrests: 19,
  },
  {
    arrest_date: "2/3/2026",
    days_in: 112,
    number_of_arrests: 8,
  },
  {
    arrest_date: "2/4/2026",
    days_in: 113,
    number_of_arrests: 13,
  },
  {
    arrest_date: "2/5/2026",
    days_in: 114,
    number_of_arrests: 15,
  },
  {
    arrest_date: "2/6/2026",
    days_in: 115,
    number_of_arrests: 12,
  },
  {
    arrest_date: "2/7/2026",
    days_in: 116,
    number_of_arrests: 3,
  },
  {
    arrest_date: "2/8/2026",
    days_in: 117,
    number_of_arrests: 4,
  },
  {
    arrest_date: "2/9/2026",
    days_in: 118,
    number_of_arrests: 14,
  },
  {
    arrest_date: "2/10/2026",
    days_in: 119,
    number_of_arrests: 5,
  },
  {
    arrest_date: "2/11/2026",
    days_in: 120,
    number_of_arrests: 13,
  },
  {
    arrest_date: "2/12/2026",
    days_in: 121,
    number_of_arrests: 12,
  },
  {
    arrest_date: "2/13/2026",
    days_in: 122,
    number_of_arrests: 6,
  },
  {
    arrest_date: "2/14/2026",
    days_in: 123,
    number_of_arrests: 4,
  },
  {
    arrest_date: "2/15/2026",
    days_in: 124,
    number_of_arrests: 6,
  },
  {
    arrest_date: "2/16/2026",
    days_in: 125,
    number_of_arrests: 11,
  },
  {
    arrest_date: "2/17/2026",
    days_in: 126,
    number_of_arrests: 8,
  },
  {
    arrest_date: "2/18/2026",
    days_in: 127,
    number_of_arrests: 10,
  },
  {
    arrest_date: "2/19/2026",
    days_in: 128,
    number_of_arrests: 10,
  },
  {
    arrest_date: "2/20/2026",
    days_in: 129,
    number_of_arrests: 8,
  },
  {
    arrest_date: "2/21/2026",
    days_in: 130,
    number_of_arrests: 3,
  },
  {
    arrest_date: "2/22/2026",
    days_in: 131,
    number_of_arrests: 2,
  },
  {
    arrest_date: "2/23/2026",
    days_in: 132,
    number_of_arrests: 1,
  },
  {
    arrest_date: "2/24/2026",
    days_in: 133,
    number_of_arrests: 4,
  },
  {
    arrest_date: "2/25/2026",
    days_in: 134,
    number_of_arrests: 9,
  },
  {
    arrest_date: "2/26/2026",
    days_in: 135,
    number_of_arrests: 10,
  },
  {
    arrest_date: "2/27/2026",
    days_in: 136,
    number_of_arrests: 10,
  },
  {
    arrest_date: "2/28/2026",
    days_in: 137,
    number_of_arrests: 6,
  },
  {
    arrest_date: "3/1/2026",
    days_in: 138,
    number_of_arrests: 9,
  },
  {
    arrest_date: "3/2/2026",
    days_in: 139,
    number_of_arrests: 12,
  },
  {
    arrest_date: "3/3/2026",
    days_in: 140,
    number_of_arrests: 10,
  },
  {
    arrest_date: "3/4/2026",
    days_in: 141,
    number_of_arrests: 10,
  },
  {
    arrest_date: "3/5/2026",
    days_in: 142,
    number_of_arrests: 7,
  },
  {
    arrest_date: "3/6/2026",
    days_in: 143,
    number_of_arrests: 3,
  },
  {
    arrest_date: "3/7/2026",
    days_in: 144,
    number_of_arrests: 6,
  },
  {
    arrest_date: "3/8/2026",
    days_in: 145,
    number_of_arrests: 5,
  },
  {
    arrest_date: "3/9/2026",
    days_in: 146,
    number_of_arrests: 12,
  },
  {
    arrest_date: "3/10/2026",
    days_in: 147,
    number_of_arrests: 5,
  },
  {
    arrest_date: "3/11/2026",
    days_in: 148,
    number_of_arrests: 9,
  },
  {
    arrest_date: "3/12/2026",
    days_in: 149,
    number_of_arrests: 2,
  },
  {
    arrest_date: "3/13/2026",
    days_in: 150,
    number_of_arrests: 3,
  },
  {
    arrest_date: "3/14/2026",
    days_in: 151,
    number_of_arrests: 1,
  },
];
